import HomepageButtons from '@components/HomepageButtons';

import { useI18n } from '@lib/i18n';
import { HOME_TITLE, HOME_DESCRIPTION, HIDE_HOMEPAGE_LOGO, CDN_URL } from '@lib/constants';

import style from '@styles/welcome.module.scss';
import HomepageLogo from '../HomepageLogo';

export default function RegularHomepage({
	animationClass = '',
	animationData = {},
}) {
	const { t } = useI18n();

	const formattedDescription = HOME_DESCRIPTION.replace(/\\n/g, '\n');

	return (
		<>
			<HomepageLogo
				animationClass={animationClass}
				animationData={animationData}
			/>

		
			<h1
				className={`has-text-align-center has-2-font-size ${animationClass}`}
				{...animationData}
			>
				{t('home.title', HOME_TITLE)}
			</h1>

			<p
				style={{ whiteSpace: 'pre-wrap' }}
				className={`has-text-align-center mb-5 ${animationClass}`}
				{...animationData}
			>
				{t('home.description', formattedDescription)}
			</p>

			<div
				className={`is-flex is-justify-content-center is-flex-wrap-wrap has-text-align-center mb-5 homeLayout__buttons ${style.btnContainer}`}
			>
				<HomepageButtons />
			</div>
		</>
	);
}